function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#373A36;}\n\t.st1{fill:#9C4877;}\n\t.st2{fill:#F8F8F7;}\n\t.st3{fill:#E2E2DC;}\n\t.st4{fill:#E64B38;}\n\t.st5{fill:#EFB8A9;}\n\t.st6{fill:none;stroke:#CCCCCC;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st7{fill:#FFC557;}\n\t.st8{fill:none;stroke:#373A36;stroke-width:0.4213;stroke-miterlimit:10;}\n\t.st9{fill:#4A9462;}\n\t.st10{fill:none;stroke:#F8F8F7;stroke-width:0.5;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "9.911,9.557 0.354,0 0,0.354 9.557,9.911 0,19.467 0.354,19.821 9.911,10.264 19.467,19.82  19.82,19.467 10.264,9.911 19.821,0.354 19.468,0 "
});

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.821 19.821",
    style: {
      enableBackground: "new 0 0 19.821 19.821"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.8e60f980.svg";
export { ForwardRef as ReactComponent };